<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      show-save-button
      unit="请假"
      id-key="LeaveId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学期名称" prop="TermId" class="longLabel">
              <el-select
                v-model="data.TermId"
                size="mini"
                @change="termChange"
                :style="isMB?'':'width:200px;'"
              >
                <el-option
                  v-for="item in termList"
                  :key="item.TermId"
                  :value="item.TermId"
                  :label="item.TermName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学生姓名" prop="StudentId" class="longLabel">
              <el-input
                size="mini"
                v-model="data.FullName"
                placeholder="点击选择"
                readonly
                @focus="onSTCDialog"
                :style="isMB?'':'width:200px;'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="请假类型" prop="LeaveType" class="longLabel">
              <el-select v-model="data.LeaveType" size="mini" :style="isMB?'':'width:200px;'">
                <el-option v-for="(item,index) in typeList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="请假开始日期" prop="StartDate" class="longLabel">
              <el-date-picker
                v-model="data.StartDate"
                value-format="yyyy-MM-dd"
                size="mini"
                :style="isMB?'width:auto;':'width:200px;'"
                placeholder="请选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始节次" prop="StartSectionId" class="longLabel">
              <el-select v-model="data.StartSectionId" size="mini" :style="isMB?'':'width:200px;'">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="请假结束日期" prop="EndDate" class="longLabel">
              <el-date-picker
                v-model="data.EndDate"
                value-format="yyyy-MM-dd"
                size="mini"
                :style="isMB?'width:auto;':'width:200px;'"
                placeholder="请选择结束时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="结束节次" prop="EndSectionId" class="longLabel">
              <el-select v-model="data.EndSectionId" size="mini" :style="isMB?'':'width:200px;'">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <stc-dialog ref="stcDialog" in-dialog selectable :multiple="false" @select="setSTC" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import stcDialog from "@/components/st/sc/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stcDialog,
  },
  data() {
    return {
      data: {
        LeaveId: 0,
        SectionId: 0,
        StudentId: null,
        FullName: "",
        TeacherId: null,
        TermId: null,
        TermNumber: "",
        StartDate: "",
        EndDate: "",
        StartSectionId: null,
        // StartSection: "",
        EndSectionId: null,
        // EndSection: "",
        LeaveType: "",
        Status: "正常",
        ClassId: null,
        GradeId: null,
      },
      api: require("@/api/st/leave").default,
      sectionApi: require("@/api/ed/section").default,
      termApi,
      termList: [],
      typeList: ["病假", "事假", "公假", "其他"],
      sectionList: [],
      isMB: this.$store.state.isMB,
      startLimit: "",
      endLimit: "",
      rules: {
        StudentId: [{ required: true, message: "请选择学生" }],
        TermId: [{ required: true, message: "请选择学期" }],
        StartDate: [{ required: true, message: "请选择开始时间" }],
        EndDate: [{ required: true, message: "请选择结束时间" }],
        LeaveType: [{ required: true, message: "请选择请假类型" }],
        StartSectionId: [{ required: true, message: "请选择开始节次" }],
        EndSectionId: [{ required: true, message: "请选择结束节次" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.getOption();
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.data.TeacherId = loginInfo.TeacherId;
      if (loginInfo.TermId > 0) this.data.TermId = loginInfo.TermId;
      else this.data.TermId = Number(sessionStorage.getItem("termId"));
      if (data) {
        this.getSection(data.TermId, data.GradeId);
      }
    },
    onEditOpened(row) {
      this.getOption();
      this.getSection(row.TermId, row.GradeId);
    },
    getOption() {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        // this.data.TermNumber = sessionStorage.getItem("termNumber")
        res.Data.forEach((item) => {
          if (this.data.TermId == item.TermId) {
            this.startLimit = item.StartTime;
            this.endLimit = item.EndTime;
          }
        });
      });
    },
    getSection(TermId, GradeId) {
      if (TermId && GradeId) {
        this.sectionApi.list({ TermId, GradeId }).then((res) => {
          this.sectionList = res.Data;
        });
      }
    },
    onBeforeSave() {
      if (
        this.data.StartDate.split(" ")[0] == this.data.EndDate.split(" ")[0]
      ) {
        let index1 = null;
        let index2 = null;
        this.sectionList.forEach((e, index) => {
          if (this.data.StartSectionId == e.SectionId) {
            index1 = index;
          }
          if (this.data.EndSectionId == e.SectionId) {
            index2 = index;
          }
        });
        if (index1 > index2) {
          this.$message.error("当天请假的，开始节次不得在结束节次之后");
          return false;
        }
      }
      if (this.data.StartDate > this.data.EndDate) {
        this.$message.error("开始时间不能大于结束时间");
        return false;
      }
      if (
        this.data.StartDate < this.startLimit.split(" ")[0] ||
        this.data.EndDate > this.endLimit.split(" ")[0]
      ) {
        this.$message.error("请假时间不在所选学期范围内");
        return false;
      }
      // return false
    },
    termChange(e) {
      this.termList.forEach((item) => {
        if (e == item.TermId) {
          this.startLimit = item.StartTime;
          this.endLimit = item.EndTime;
          this.data.StudentId = null;
          this.data.FullName = null;
          this.data.StartSectionId = null;
          this.data.EndSectionId = null;
          this.sectionList = [];
        }
      });
    },
    onSTCDialog() {
      this.$refs.stcDialog.open().then((that) => {
        that.getDataWithClass(this.data.TermId, this.data.TeacherId);
      });
    },
    setSTC(stc) {
      console.log(stc);
      this.data.StudentId = stc.StudentId;
      this.data.FullName = stc.FullName;
      this.data.ClassId = stc.ClassId;
      console.log(stc.GradeId != this.data.GradeId);
      if (stc.GradeId != this.data.GradeId) {
        this.data.GradeId = stc.GradeId;
        this.getSection(this.data.TermId, stc.GradeId);
        this.data.StartSectionId = null;
        this.data.EndSectionId = null;
      }
    },
  },
};
</script>
<style lang="scss">
</style>